<template>
    <div>
        <div v-if="showWallets === 'true'">
            <div class="d-block d-md-flex align-items-center">
                <h3 class="title-content m-0">Meus Créditos</h3>
            </div>
            <div class="form-profile col-12" v-if="wallets.length > 0">
                <v-row justify="center">
                    <v-expansion-panels class="wallet" inset>
                        <v-expansion-panel v-for="wallet in wallets" :key="wallet.id">
                            <v-expansion-panel-header>
                                <v-list-item class="wallet">
                                    <v-list-item-avatar class="wallet-icon">
                                        <i class="fas fa-wallet" style="color: #ffffff"></i>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="wallet-name">{{wallet.name}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="content-wallet">
                                <div>
                                    <div class="wallet-currency">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="mx-5">
                                                <h6>Crédito</h6>
                                                <span class="prefix">R$</span><span>{{wallet.balance_credit | integerToMoney | integerToMoney2 }}</span>
                                            </div>
                                            <div class="mx-5">
                                                <h6>Bônus</h6>
                                                <span class="prefix">R$</span><span>{{wallet.balance_bonus | integerToMoney | integerToMoney2}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "Wallets",
        data:function () {
            return{
                expanded:true,
                loading:false,
                wallets:[],
                wallet_selected:{},
                shares:[],
            }
        },
        methods:{
            init:function () {
                this.loading = true;
                axios.get('/api/users/driver/me/wallet').then(response =>{
                  this.wallets = response.data.data;
                  this.loading = false;
                });
            }
        },
        mounted() {
            this.init();
        },
        computed:{
            showWallets(){
                return process.env.VUE_APP_SHOW_WALLETS;
            }
        }

    }
</script>

<style scoped>
    .wallet:hover{
        cursor: pointer;
    }

    .wallet{
        margin-bottom: 10px;
    }

    .v-expansion-panel-header{
        padding-top: 10px;
        padding-bottom: 3px;
    }

    .wallet-name{
        font-size: 16px;
        font-family: Roboto-Black;
        color: #000;
    }

    .wallet-icon{
        background: #000;
    }

    .wallet-subtitle{
        font-size: 12px;
        font-family: Roboto-Regular;
    }

    .header-icons{
        color: #a8a8a8;
        font-size: 12px;
        padding-top: 10px;
    }

    .header-icons span{
        margin: 0 10px 0 5px;
        font-family: Roboto-Regular;
    }

    .content-wallet{
        padding: 0 30px;
        font-size: 14px;
        font-family: Roboto-Regular;
        color: #595959;
        margin-bottom: 30px;
    }

    .wallet-currency{
        display: block;
        width: 100%;
        margin-bottom: 30px;
    }


    .wallet-currency span{
        font-size: 32px;
        font-family: Roboto-Black;
        color: #000 !important;
        margin: 0;
    }

    .wallet-currency span.prefix{
        font-size: 12px;
        font-family: Roboto-Black;
        color: #000 !important;
        margin: 0;
        margin-right: 5px;
    }

    .wallet-currency h6{
        font-size: 12px;
        font-family: Roboto-Light;
        color: #a8a8a8;
        margin: 0;
    }

    @media only screen and (max-width: 500px) {
        .wallet{
            width: 90vw;
            height: auto;
        }
        .header-icons{
            padding-top: 18px;
        }
        .wallet-currency{
            width: 100%;
            height: auto;
            padding: 0;
            margin: 0;
            border: 0;
            text-align: center;
        }
        .btn-confirm, .btn-cancel{
            width: 100% !important;
            margin: 5px 0;
        }
        .content-wallet{
            height: auto;
            padding: 0;
        }

        .wallet-icon{
            display: none;
        }
    }

    @media only screen and (min-width: 501px) and (max-width: 1024px) {
        .wallet-vehicles,.wallet-shares{
            width: auto;
        }
    }

</style>
